<template>
  <div class="container bottom-fix-padding">
    <v-suburb v-show="returnSuburbIf" @change="changeReturnSuburb" @close="returnClose()"></v-suburb>

    <div class="core" v-show="!pickSuburbIf&&!returnSuburbIf">
      <div class="navi">
          <span class="icon-arrow-left" @click="goto('/warehouse-step3')"></span>
      </div>
      <div class="title">请填写送回详情</div>
      <img class="promo-image" src='../../assets/img/warehouse/pickreturn.png'>
      <div class="main">
          <div class="core">
            <div>
                <div class="weui-cells__title big to-return">送回详情</div>

                <div class="weui-cells weui-cells_checkbox">
                    <label class="weui-cell weui-check__label" for="s11">
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox1" id="s11" value="0" v-model="order.data.ifSelfReturn">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>到家负责送回货物</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s12" >
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox1" class="weui-check" id="s12" value="1" v-model="order.data.ifSelfReturn">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>我去仓库自取货物（费用更低）</p>
                        </div>
                    </label>
                </div>
                <div class="weui-cells weui-cells_checkbox"  v-show="order.data.ifSelfReturn==1">
                    <label class="weui-cell weui-check__label" for="s13" v-show="!order.data.warehouse || order.data.warehouse=='Peakhurst' || order.data.ifSelfPick==0">
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox2" id="s13" value="Peakhurst" v-model="order.data.warehouse">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>Peakhurst仓库 （近Hurstville）</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s14"   v-show="!order.data.warehouse || order.data.warehouse=='Auburn' || order.data.ifSelfPick==0 ">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox2" class="weui-check" id="s14" value="Auburn" v-model="order.data.warehouse">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>Auburn仓库</p>
                        </div>
                    </label>
                </div>
                <div class="weui-cells__title big to-return" v-show="order.data.ifSelfReturn=='0'">送回地址</div>
                <div class="weui-cells weui-cells_checkbox" v-show="order.data.ifSelfReturn=='0'">
                    <label class="weui-cell weui-check__label" for="s23" v-show="order.data.ifSelfPick==0">
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox3" id="s23" value="0" v-model="order.data.return_addr_pending">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>跟取货地址相同</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s24" >
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox3" class="weui-check" id="s24" value="2" v-model="order.data.return_addr_pending">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p v-show="order.data.ifSelfPick==0">跟取货地址不同，我要填写另一个地址</p>
                            <p v-show="order.data.ifSelfPick==1">我有确定的送回地址，现在填写</p>
                        </div>
                    </label>
                    
                    <label class="weui-cell weui-check__label" for="s25">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox3" class="weui-check" id="s25" value="1" v-model="order.data.return_addr_pending">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>暂时无法确定，送回前我再联系客服</p>
                        </div>
                    </label>
                </div>
                
                <div class="weui-cells weui-cells_form" v-show="order.data.ifSelfReturn==0 && order.data.return_addr_pending==2">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="如: Unit 2, 9 Hunter St" v-model="order.data.return_street">
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_access padding-fix"  @click="returnSelect()">
                        <div class="weui-cell__hd">
                            <label class="weui-label">Suburb</label>
                        </div>
                        <div class="weui-cell__bd" v-if="order.data.return_suburb==''"> 
                            <p class="placeholder-color">如: Chatswood</p>
                        </div>
                        <div class="weui-cell__bd" v-if="order.data.return_suburb!=''"> 
                            <p>{{order.data.return_suburb}}</p>
                        </div>
                        <div class="weui-cell__ft"></div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" >
                                <option value="NSW" selected>NSW</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell" >
                        <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text"  placeholder="如：2000" v-model="order.data.return_postcode">
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title to-parking" v-show="order.data.return_suburb  && order.data.ifSelfReturn==0 && order.data.return_addr_pending==2">停车位</div>
                <div class="weui-cells weui-cells_checkbox" v-show="order.data.return_suburb  && order.data.ifSelfReturn==0 && order.data.return_addr_pending==2">
                    <label class="weui-cell weui-check__label" for="s61">
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox4" id="s61" value="1" v-model="order.data.return_parking" @click="scrollToParking()">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>我已经预定好Loading Dock </p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s62">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox4" class="weui-check" id="s62" value="2" v-model="order.data.return_parking"  @click="scrollToParking()">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>我在门口预留了停车位置</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s63">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox4" class="weui-check" id="s63" value="3" v-model="order.data.return_parking" @click="scrollToParking()">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>我无法提供停车位 </p>
                        </div>
                    </label>

                    <label class="weui-cell weui-check__label" for="s34" v-if="isEditing">
                        <div class="weui-cell__bd">
                            <p class="park-assist" @click="$router.push('/move-parking');"> <span class="icon-help-circle parking-icon"></span> 教我如何选择这个 </p>
                        </div>
                    </label>

                    <label class="weui-cell weui-check__label" for="s34" v-if="!isEditing">
                        <div class="weui-cell__bd">
                            <p class="park-assist" @click="orderUpdateAll('/move-parking')"> <span class="icon-help-circle parking-icon"></span> 教我如何选择这个 </p>
                        </div>
                    </label>
                </div>

                <div class="weui-cells__title" v-show="order.data.return_suburb && order.data.ifSelfReturn==0 && order.data.return_addr_pending==2">楼层电梯 (含复式户型内部楼梯)</div>

                <div class="weui-cells weui-cells_checkbox" v-show="order.data.return_suburb && order.data.ifSelfReturn==0 && order.data.return_addr_pending==2">
                    <label class="weui-cell weui-check__label" for="k11">
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox5" id="k11" value="1" v-model="order.data.return_floor">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>住处有电梯，或住Ground层</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="k12">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox5" class="weui-check" id="k12" value="2" v-model="order.data.return_floor">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>无电梯，需走1层楼梯</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="k13">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox5" class="weui-check" id="k13" value="3" v-model="order.data.return_floor">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>无电梯，需走2层楼梯</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="k14">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox5" class="weui-check" id="k14" value="4" v-model="order.data.return_floor">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>无电梯，需走3层楼梯</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="k15">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox5" class="weui-check" id="k15" value="5" v-model="order.data.return_floor">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>无电梯，需走4层楼梯</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="k16">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox5" class="weui-check" id="k16" value="6" v-model="order.data.return_floor">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>无电梯，需走5层楼梯</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="k17">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox5" class="weui-check" id="k17" value="7" v-model="order.data.return_floor">
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>无电梯并5层以上，预定后客服与您联系</p>
                        </div>
                    </label>
                </div>
            </div>
        </div>

      </div>
      <br>  
      <div class="weui-panel" v-show="order.data.ifSelfReturn!=0">
          <div class="weui-panel__hd">📍到家仓库地址（点击在地图上打开）</div>
          <div class="weui-panel__bd">
              <div class="weui-media-box weui-media-box_small-appmsg">
                  <div class="weui-cells">
                      <a class="weui-cell weui-cell_active weui-cell_access weui-cell_example" href="https://maps.google.com/?q=4/63+Norman+St,+Peakhurst+NSW+2210+Australia" target="_blank">
                          
                          <div class="weui-cell__bd weui-cell_primary">
                              <p>Peakhurst </p>
                              <p class="weui-media-box__desc">4/63 Norman St, Peakhurst NSW 2210 </p>
                          </div>
                          <span class="weui-cell__ft"></span>
                      </a>
                      <a class="weui-cell weui-cell_active weui-cell_access weui-cell_example" href="https://maps.google.com/?q=38/7+Percy+Street,+Auburn+NSW+2144+Australia" target="_blank">
                          <div class="weui-cell__bd weui-cell_primary">
                              <p>Auburn </p>
                              <p class="weui-media-box__desc">38/7 Percy Street, Auburn NSW 2144 </p>
                          </div>
                          <span class="weui-cell__ft"></span>
                      </a>
                  </div>
              </div>
          </div>
      </div>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}" >下一步</div>
        </div>
      </div>
      <div v-show="localErrorShow">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__bd">{{localError[0]}}</div>
              <div class="weui-dialog__ft">
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
              </div>
          </div>
      </div>
      
    </div>

    <img :src="pixelURL('cangchu','step4')" class="hide">
  </div>
</template>

<script>
import anime from 'animejs';

export default {
  name: 'step4',
  data () {
    return {
      returnSuburbIf:false,
      pickSuburbIf:false,
      localError:[],
      localErrorShow:false,
      isEditing : localStorage.isEditing,
      order:{
      }
    }
  },
  created: function () {
    document.querySelector("html").classList.add("grey-background");
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "warehouse"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    allFilled(){
      return true;
    },
    checkSubmit(){
      this.localError = [];
      if(this.order.data.ifSelfReturn=="1"){
        if(this.order.data.warehouse){
          this.orderUpdateAll('/warehouse-step5');
          return false;
        }
        else{
          this.localError.push("请选择仓库地址");
          this.localErrorShow = true;
          return false;
        }
      }
      else{
        if(this.order.data.ifSelfReturn==""){
          this.localError.push("请选择送回方式");
        }
        if(this.order.data.return_addr_pending==""){
          this.localError.push("请填写送回地址");
        }
        if(this.order.data.return_addr_pending=="2"){
          if (!this.order.data.return_street) {
            this.localError.push("请填写送回 Street 地址");
          } else if (this.order.data.return_street.length<8) {
            this.localError.push("送回 Street 地址长度太短，请检查是否正确");
          } else if (this.order.data.return_street.length>40) {
            this.localError.push("送回 Street 地址长度太长，请检查是否正确");
          }
          if (!this.order.data.return_suburb) {
            this.localError.push("请选择送回地址 Suburb");
          }
          if (!this.order.data.return_postcode) {
            this.localError.push("请填写4位送回地址 Postcode 号码");
          } else if (this.order.data.return_postcode.length!=4) {
            this.localError.push("请填写4位送回地址 Postcode 号码");
          }
          if (!this.order.data.return_parking) {
            this.localError.push("请选择停车位情况");
          }
          if (!this.order.data.return_floor) {
            this.localError.push("请选择楼层电梯情况");
          }
        }

        if (!this.localError.length) {
          this.orderUpdateAll('/warehouse-step5');
        }
        else{
          this.localErrorShow = true;
          return false;
        }
      }

    },
    scroll(arg) {
        let el = document.querySelector(arg.to),
            offset = parseInt(arg.offset) || 0,
            duration = arg.duration || 1500,
            easing = arg.easing || 'easeInOutQuart',
            callback = arg.callback || null;

        if ( el ) {
            anime({
                targets: ['html', 'body'],
                scrollTop: (el.offsetTop - offset),
                duration: duration,
                easing: easing,
                complete: callback
            })
            .finished.then(() => {
                this.$emit('scroll:finished', true);
            });
        }
    },
    scrollToParking(){
        this.scroll({ 
            to: '.to-parking'
        });
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    pickSelect: function() {
        this.rememberTop = window.scrollY;
        this.pickSuburbIf=true;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    returnSelect: function() {
        this.rememberTop = window.scrollY;
        this.returnSuburbIf=true;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },

    changePickSuburb: function(suburb,postcode) {
        this.order.data.return_suburb = suburb;
        this.order.data.return_postcode = postcode.toString();
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.pickSuburbIf=false;
    },
    pickClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.pickSuburbIf=false;
    },

    changeReturnSuburb: function(suburb,postcode) {
        this.order.data.return_suburb = suburb;
        this.order.data.return_postcode = postcode.toString();
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.returnSuburbIf=false;
    },
    returnClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        this.returnSuburbIf=false;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.hr{
  border-top:1px solid #eee;
  margin:16pt 0;
}
.address-empty{
  color:#ccc;
  font-size:1.2em;
}

.container /deep/ .weui-cells__title.big{
  color:#666;
  font-size:18px;
  margin-top:20px;
}

.container /deep/ .weui-cell_active{
  padding:12px 15px 15px 15px;
}

.container /deep/ .weui-panel__hd{
  color:#2c3e50;
}


.address-detail{
  color:#666;
  font-size:1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address-parking{
  color:#aaa;
  font-size:1em;
}

.arrow-right{
  color:#ddd;
}
.move-title{
  font-weight:bold;
  font-size:1.2em;
  color:#555;
  margin-bottom:4pt;
}

.waypoint{
  font-weight:bold;
  font-size:1.2em;
  color:#777;
  margin-bottom:4pt;
}

select{
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  height: 45px;
  line-height: 45px;
  position: relative;
  z-index: 1;
}

.fade-enter-active{
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
}

.more-detail{
  text-align:center;
  margin-bottom:20px;
}

.promo-image{
  width:80%;
  margin:6px auto;
  display:block;
}
.park-assist{
    text-align:center;
    color:#fe9567;
}
</style>



// WEBPACK FOOTER //
// src/pages/warehouse/step4.vue